var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import isEmpty from 'lodash/isEmpty';
import { action, observable } from 'mobx';
import { getInforUserAction } from '@gtintel/platform-api';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
import { getSessionStorageItem } from '@gtintel/platform-utils';
let AuthStore = (_class = class AuthStore {
  constructor(rootStore) {
    this.rootStore = void 0;
    _initializerDefineProperty(this, "authUsers", _descriptor, this);
    this.rootStore = rootStore;
  }
  async getAuthUsers() {
    const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
    if (!isEmpty(user)) {
      const usersResponse = await getInforUserAction(user?.email, false);
      this.authUsers = usersResponse.results;
      return this.authUsers;
    }
    return [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "authUsers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "getAuthUsers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getAuthUsers"), _class.prototype), _class);
export { AuthStore as default };